// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","header-heading":"Header_header-heading___ZzN0","header-writer":"Header_header-writer__RQhe1"};